import React, { useState, useEffect } from "react";
import ObjDisplay from "../objDisplay/objDisplay";

const NotesForm = ({ initialData, onSubmit }) => {
  const [newNote, setNewNote] = useState("");

  useEffect(() => {
    if (initialData) setNewNote(initialData);
  }, [initialData]);

  const submit = (e) => {
    e.preventDefault();
    onSubmit(newNote);
  }

  const reset = (e) => {
    e.preventDefault();
    setNewNote(initialData || "")
  }


  return (
    <form className="p-3 border rounded">

      <div className="mb-3">
        <label className="form-label">Note</label>
        <textarea
          className="form-control"
          rows="4"
          value={newNote}
          onChange={(e) => setNewNote(e.target.value)}
        />
      </div>

      <div className='modal-btn-container'>

          <button className="form-secondary-btn btn" onClick={reset}>Reset</button>
          <button className="form-primary-btn btn" onClick={submit}>Submit</button>
      </div>

    </form>

    
  );
};

export default NotesForm;
